// The schedule page's N/A Day flows. They live on api/public/v3 like self-scheduling, so the
// transport (headers, auth, body shape, error parsing) is utils/jsonApi; this module only knows
// the endpoints and the request attributes.
import appConstants from 'constants/AppConstants';
import {
  jsonApiGet, jsonApiWrite, publicV3Url, writeBody,
} from 'utils/jsonApi';

const NaApi = {
  // The JSON:API reason code (and optional details.reason) off a failed jsonApi result, so callers
  // can map it to an `na.errors.<code>` string.
  parseError({ errors }) {
    const err = errors && errors[0];
    return {
      code: (err && err.code) || null,
      reason: (err && err.details && err.details.reason) || null,
    };
  },

  // GET /api/public/v3/unavailables/na_availability?department_id=&date=
  // Resolves ok with rows[0] as { enabled, per_day_cap, current_used, full, per_block_cap,
  // period_used, period_full, period_start, period_end, published }. The per-block (per
  // scheduling period) figures are the caller's own.
  getAvailability({ departmentId, date }) {
    return jsonApiGet(publicV3Url(appConstants.EndPoints.NA_AVAILABILITY_PATH), {
      department_id: departmentId,
      date,
    });
  },

  // POST /api/public/v3/unavailables — single full-day N/A declaration.
  declare({
    userId, unavailableTypeId, date, declaringDepartmentId,
  }) {
    return jsonApiWrite(
      publicV3Url(appConstants.EndPoints.NA_UNAVAILABLES_PATH),
      'POST',
      writeBody('unavailable', {
        user_id: userId,
        unavailable_type_id: unavailableTypeId,
        start_date: date,
        end_date: date,
        partial: false,
        declaring_department_id: declaringDepartmentId,
      }),
    );
  },

  // DELETE /api/public/v3/unavailables/:id — owner self-removal.
  selfRemove(id) {
    return jsonApiWrite(`${publicV3Url(appConstants.EndPoints.NA_UNAVAILABLES_PATH)}/${id}`, 'DELETE');
  },
};

export default NaApi;
